import { render, staticRenderFns } from "./CorrelationContent.vue?vue&type=template&id=1a964535&scoped=true"
import script from "./CorrelationContent.vue?vue&type=script&lang=ts"
export * from "./CorrelationContent.vue?vue&type=script&lang=ts"
import style0 from "./CorrelationContent.vue?vue&type=style&index=0&id=1a964535&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a964535",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a964535')) {
      api.createRecord('1a964535', component.options)
    } else {
      api.reload('1a964535', component.options)
    }
    module.hot.accept("./CorrelationContent.vue?vue&type=template&id=1a964535&scoped=true", function () {
      api.rerender('1a964535', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/CorrelationContent.vue"
export default component.exports